import {
  Editor,
  Transforms,
  Path,
  Node
} from 'slate';
import * as basicEditorValueSerializer from 'basic-editor-value-serializer';

import HelptapEditor from '../';

export function getDefaultOptions() {

  return {};

}

export function buildNode(options = {}, node) {

  return {
    ...options,
    type: basicEditorValueSerializer.allTypes.types.INDENTATION,
    children: [node]
  };

}

export function select(editor, path) {

}

/**
 * 
 * Indentation rules
 * 1. If there is no parent indentation node, 
 *        if the previous node is not a indentation node, create a new indentation node and insert the current node into it.
 * 2. If there is no parent indentation node, if the previous node is a indentation node, append the current node into it.
 * 3. If there is a parent indentation node exists, 
 *        if it has only one child, do nothing.
 * 4. If there is a parent indentation node exists, 
 *        if it has more than one child & if the current node is first child, do nothing.
 * 5. If there is a parent indentation node exists, 
 *        if it has more than one child & if the current node is not first child, 
 *              create a new indentation node and insert the current node into it. 
 * 6. When no previous indentation node exists & no next indentation node exists, 
 *        create an indentation node in current path & move the current node into it.
 * 7. When no previous indentation node exists & next indentation node exists,
 *        prepend the current node into it
 * 
 * 
 * */
export function indent(editor, path) {

  const node = Node.get(editor, path);
  const parentIndetation = HelptapEditor.getClosestNodeFromPathByType(editor, path, basicEditorValueSerializer.allTypes.types.INDENTATION);

  if (parentIndetation !== null) {
    if (parentIndetation.children.length === 1) {
      return true;
    }
    if (node === parentIndetation.children[0]) {
      return true;
    }
  }

  Editor.withoutNormalizing(editor, () => {

    if (Path.hasPrevious(path) === true) {
      const previousPath = Path.previous(path);
      const previousNode = Node.get(editor, previousPath);
      if (previousNode.type === basicEditorValueSerializer.allTypes.types.INDENTATION) {
        Transforms.moveNodes(editor, { at: path, to: [...previousPath, previousNode.children.length] });
        return;
      }
    }

    const nextPath = Path.next(path);

    if (Node.has(editor, nextPath) === true) {
      const nextNode = Node.get(editor, nextPath);
      if (nextNode.type === basicEditorValueSerializer.allTypes.types.INDENTATION) {
        Transforms.moveNodes(editor, { at: path, to: [...nextPath, 0] });
        return;
      }
    }

    Transforms.insertNodes(editor, buildNode({}, node), { at: path });
    Transforms.removeNodes(editor, { at: Path.next(path) });
    Transforms.select(editor, Editor.range(editor, path));
    Transforms.collapse(editor, { edge: 'end' });

  });

  return true;

}

export function unindent(editor, path) {

  const parentIndetation = HelptapEditor.getClosestNodeFromPathByType(editor, path, basicEditorValueSerializer.allTypes.types.INDENTATION);

  if (parentIndetation === null) {
    return false;
  }

  Editor.withoutNormalizing(editor, () => {

    Transforms.splitNodes(editor, { at: path });
    Transforms.unwrapNodes(editor, { at: Path.next(Path.parent(path)) });
    Transforms.select(editor, Path.next(Path.parent(path)));
    Transforms.collapse(editor, { edge: 'end' });

  });

  return true;

}